export const collectionTopic = (slug: string) => {
  return `collection:${slug}`;
};
